import { Switch as MuiSwitch } from "@mui/material";
import { PurePtr } from "@pure-ptr/react";
import React, { ComponentProps } from "react";

export const Switch = ({ checkedPtr, ...props } : {
    checkedPtr: PurePtr<boolean> 
} & ComponentProps<typeof MuiSwitch> ) =>
    <MuiSwitch
        {...props}
        checked={checkedPtr.value}
        onChange={e => {
            checkedPtr.set(e.target.checked);
        }}
    />